"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseTypes = exports.RequestTypes = exports.LoginPrio = exports.TypeOfLogin = exports.Networks = void 0;
var Networks;
(function (Networks) {
    Networks["mainnet"] = "mainnet";
    Networks["ghostnet"] = "ghostnet";
    Networks["ithacanet"] = "ithacanet";
    Networks["jakartanet"] = "jakartanet";
    Networks["kathmandu"] = "kathmandu";
    Networks["dev"] = "dev";
    Networks["local"] = "local";
})(Networks = exports.Networks || (exports.Networks = {}));
var TypeOfLogin;
(function (TypeOfLogin) {
    TypeOfLogin["Google"] = "google";
    TypeOfLogin["Reddit"] = "reddit";
    TypeOfLogin["Twitter"] = "twitter";
    TypeOfLogin["Facebook"] = "facebook";
})(TypeOfLogin = exports.TypeOfLogin || (exports.TypeOfLogin = {}));
var LoginPrio;
(function (LoginPrio) {
    LoginPrio["LowFast"] = "low_always_skip_key";
    LoginPrio["Low"] = "low";
    LoginPrio["High"] = "high";
})(LoginPrio = exports.LoginPrio || (exports.LoginPrio = {}));
var RequestTypes;
(function (RequestTypes) {
    RequestTypes["loginRequest"] = "login_request";
    RequestTypes["operationRequest"] = "operation_request";
    RequestTypes["trackRequest"] = "track_request";
    RequestTypes["logoutRequest"] = "logout_request";
    RequestTypes["signExprRequest"] = "sign_expr_request";
    RequestTypes["authRequest"] = "authentication_request";
    RequestTypes["cardRequest"] = "card_request";
    RequestTypes["dismissRequest"] = "dismiss_request";
})(RequestTypes = exports.RequestTypes || (exports.RequestTypes = {}));
var ResponseTypes;
(function (ResponseTypes) {
    ResponseTypes["initComplete"] = "init_complete";
    ResponseTypes["loginResponse"] = "login_response";
    ResponseTypes["operationResponse"] = "operation_response";
    ResponseTypes["trackResponse"] = "track_response";
    ResponseTypes["logoutResponse"] = "logout_response";
    ResponseTypes["signExprResponse"] = "sign_expr_response";
    ResponseTypes["authResponse"] = "authentication_response";
    ResponseTypes["cardResponse"] = "card_response";
    ResponseTypes["dismissResponse"] = "dismiss_response";
})(ResponseTypes = exports.ResponseTypes || (exports.ResponseTypes = {}));
